var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGroup7629(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_7629",
    "data-name": "Group 7629",
    transform: "translate(-1840 -110)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6676",
    "data-name": "Rectangle 6676",
    width: 50,
    height: 50,
    rx: 6,
    transform: "translate(1840 110)",
    fill: "#f2824c"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_7627",
    "data-name": "Group 7627",
    transform: "translate(0 -3)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6430",
    "data-name": "Rectangle 6430",
    width: 30,
    height: 30,
    transform: "translate(1850 123)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7259",
    "data-name": "Path 7259",
    d: "M11.721.264a3.154,3.154,0,0,0-2.178.92L8.37,2.357H5.489A3.165,3.165,0,0,0,2.344,5.5V8.381L1.18,9.555a3.156,3.156,0,0,0,0,4.44l1.164,1.173v2.881a3.165,3.165,0,0,0,3.145,3.145H8.37l1.173,1.164a3.156,3.156,0,0,0,4.44,0l1.175-1.164h2.879a3.165,3.165,0,0,0,3.145-3.145V15.168L22.355,14a3.156,3.156,0,0,0,0-4.44L21.182,8.381V5.5a3.165,3.165,0,0,0-3.145-3.145H15.158L13.983,1.184a3.133,3.133,0,0,0-2.261-.92Zm.031,2.092a1.036,1.036,0,0,1,.749.309L13.983,4.14a1.046,1.046,0,0,0,.743.309h3.311a1.038,1.038,0,0,1,1.05,1.05V8.814a1.046,1.046,0,0,0,.311.742l1.475,1.481a1.025,1.025,0,0,1,0,1.475L19.4,14a1.046,1.046,0,0,0-.311.742v3.312a1.038,1.038,0,0,1-1.05,1.05H14.725a1.046,1.046,0,0,0-.742.3L12.5,20.883a1.025,1.025,0,0,1-1.475,0L9.543,19.4a1.046,1.046,0,0,0-.742-.3H5.489a1.038,1.038,0,0,1-1.05-1.05V14.737a1.046,1.046,0,0,0-.3-.742L2.655,12.512a1.025,1.025,0,0,1,0-1.475L4.137,9.555a1.046,1.046,0,0,0,.3-.743V5.5a1.038,1.038,0,0,1,1.05-1.05H8.8a1.046,1.046,0,0,0,.742-.308l1.484-1.475a1.053,1.053,0,0,1,.725-.309Zm3.128,5.22a1.046,1.046,0,0,0-.72.317L7.882,14.173a1.049,1.049,0,1,0,1.483,1.483l6.279-6.279a1.046,1.046,0,0,0-.764-1.8ZM8.626,7.59A1.046,1.046,0,1,0,9.672,8.636,1.046,1.046,0,0,0,8.626,7.59ZM14.9,13.867a1.046,1.046,0,1,0,1.046,1.046A1.046,1.046,0,0,0,14.9,13.867Z",
    transform: "translate(1852.733 125.736)",
    fill: "#fff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup7629);
export default __webpack_public_path__ + "static/media/Group 7629.0fc54831a83462f6f9ada9809df46cde.svg";
export { ForwardRef as ReactComponent };